export default "__VITE_ASSET__0ac8e1c7__"